import {utcDayAsLocalDate} from '@/shared/utils/utc-day'
import {getCalendarDaysDiffBetweenDates} from '@cypro/ui/utils'
import {EXPIRING_DAYS_THRESHOLD} from '@cypro/engine/queries'
import type {Batch} from '@cypro/engine/schema'

export function isNearExpiry(date: Date | number | null | undefined, thresholdDays = EXPIRING_DAYS_THRESHOLD): boolean {
  if (!date) return false
  const days = getCalendarDaysDiffBetweenDates(new Date(), date)
  return days <= thresholdDays
}

/**
 * Days a batch can still be used, counting today: a batch expiring today has 1 day left, tomorrow 2, and one that
 * expired yesterday 0. The expiry is a calendar day (CY-371), so it is compared in the user's own calendar.
 */
export function getBatchDaysLeft(expiryDate: Date | number): number {
  return getCalendarDaysDiffBetweenDates(new Date(), utcDayAsLocalDate(new Date(expiryDate).getTime())) + 1
}

/** Expiring soon: still usable, with at most the threshold's days left. */
export function isBatchExpiringSoon(expiryDate: Date | number, thresholdDays = EXPIRING_DAYS_THRESHOLD): boolean {
  const daysLeft = getBatchDaysLeft(expiryDate)
  return daysLeft > 0 && daysLeft <= thresholdDays
}

export function isBatchExpired(batch: Batch): boolean {
  if (!batch.expiryDate) return false
  // a batch expiry is a calendar day; it is expired from the next day on (CY-371)
  return isNearExpiry(utcDayAsLocalDate(batch.expiryDate), -1)
}

export function isBatchDisposed(batch: Batch): boolean {
  return isBatchExpired(batch) && Boolean(batch.acknowledgedAt)
}
